// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SummaryReport_wrapper__UhsCP {
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  padding: 1.5rem;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.SummaryReport_title__0PGMz {
  margin: 0 0 1rem 0;
  font-size: 1.25rem;
  color: #333;
}

.SummaryReport_controls__85nVz {
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
  align-items: center;
}

.SummaryReport_label__oNJ4M {
  font-size: 0.9rem;
  color: #444;
}

.SummaryReport_dateInput__0tBw4 {
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 0.3rem 0.5rem;
  font-size: 0.9rem;
}

.SummaryReport_colorToggle__9Zcsc {
  display: flex;
  align-items: center;
  font-size: 0.9rem;
  color: #444;
}

.SummaryReport_loading__NeSxa {
  padding: 2rem;
  text-align: center;
  color: #666;
}

.SummaryReport_tableContainer__juEKr {
  overflow-x: auto;
}

.SummaryReport_table__BSPgX {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed; /* фиксируем, чтобы перенос работал */
  font-size: 0.9rem;
}

.SummaryReport_table__BSPgX th,
.SummaryReport_table__BSPgX td {
  border: 1px solid #ddd;
  padding: 0.5rem;
  text-align: center;
  vertical-align: top;
}

/* Заголовки столбцов */
.SummaryReport_table__BSPgX th {
  background-color: #f5f5f5;
  font-weight: 600;
  color: #333;
  white-space: normal;
  word-break: break-word;
}

/* Немного сузим столбцы со статусами */
.SummaryReport_statusHeader__4pnQb {
  width: 70px;
}

/* Ширина колонки "Товары" */
.SummaryReport_productsHeader__UUutJ {
  width: 200px;
}

/* Зебра-чередование строк */
.SummaryReport_table__BSPgX tr:nth-child(even) {
  background-color: #fafafa;
}

/* Подсветка ячеек (цвет фона) */
.SummaryReport_greenCell__H6CUq {
  background-color: #d4edda; /* бледно-зелёный фон */
  color: #155724;
  font-weight: 600;
}

.SummaryReport_yellowCell__AMtXB {
  background-color: #fff3cd; /* бледно-жёлтый фон */
  color: #856404;
  font-weight: 600;
}

.SummaryReport_redCell__mxpzt {
  background-color: #f8d7da; /* бледно-красный фон */
  color: #721c24;
  font-weight: 600;
}

/* Цвет текста для товаров */
.SummaryReport_greenText__PthMz {
  color: #28a745; /* насыщенный зелёный */
  font-weight: 600;
  font-size: 0.85rem;
  margin-bottom: 2px;
}

.SummaryReport_yellowText__7zNM9 {
  color: #ff9100; /* ярко-жёлтый */
  font-weight: 600;
  font-size: 0.85rem;
  margin-bottom: 2px;
}

.SummaryReport_redText__6w9xr {
  color: #dc3545; /* насыщенный красный */
  font-weight: 600;
  font-size: 0.85rem;
  margin-bottom: 2px;
}


/* Ячейка с товарами: текст выравнивается по левому краю, можно переносить */
.SummaryReport_productsCell__7rwMn {
  text-align: left;
  white-space: normal;
  word-break: break-word;
  padding: 0.4rem;
}

.SummaryReport_noData__P9z0B {
  padding: 1rem;
  color: #777;
  text-align: center;
}


.SummaryReport_generateButton__J1qr\\+ {
  margin-left: 1rem;
  padding: 0.5rem 1rem;
  background-color: #007bff;
  border: none;
  color: #fff;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: background-color 0.2s;
}

.SummaryReport_generateButton__J1qr\\+:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
}

.SummaryReport_generateButton__J1qr\\+:not(:disabled):hover {
  background-color: #0056b3;
}

/* ...остальные стили остаются без изменений... */

.SummaryReport_filterSelect__oMJI9 {
  margin-left: 0.5rem;
  padding: 0.3rem 0.5rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 0.9rem;
  background-color: #fff;
  cursor: pointer;
}

/* Если нужно, можно ещё чуть расширить ширину селекта */
.SummaryReport_filterSelect__oMJI9 {
  min-width: 120px;
}

.SummaryReport_blueText__j4NcL {
  color: #0066cc;
}`, "",{"version":3,"sources":["webpack://./src/modules/Manager/ReportsPage/components/reports/SummaryReport.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB,EAAE,qCAAqC;EAC1D,iBAAiB;AACnB;;AAEA;;EAEE,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,uCAAuC;AACvC;EACE,WAAW;AACb;;AAEA,4BAA4B;AAC5B;EACE,YAAY;AACd;;AAEA,4BAA4B;AAC5B;EACE,yBAAyB;AAC3B;;AAEA,gCAAgC;AAChC;EACE,yBAAyB,EAAE,uBAAuB;EAClD,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB,EAAE,sBAAsB;EACjD,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB,EAAE,uBAAuB;EAClD,cAAc;EACd,gBAAgB;AAClB;;AAEA,4BAA4B;AAC5B;EACE,cAAc,EAAE,uBAAuB;EACvC,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc,EAAE,gBAAgB;EAChC,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc,EAAE,uBAAuB;EACvC,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;;AAGA,4EAA4E;AAC5E;EACE,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;AACpB;;;AAGA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,iDAAiD;;AAEjD;EACE,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;AACjB;;AAEA,wDAAwD;AACxD;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".wrapper {\r\n  display: flex;\r\n  flex-direction: column;\r\n  background-color: #ffffff;\r\n  padding: 1.5rem;\r\n  border-radius: 8px;\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.title {\r\n  margin: 0 0 1rem 0;\r\n  font-size: 1.25rem;\r\n  color: #333;\r\n}\r\n\r\n.controls {\r\n  display: flex;\r\n  gap: 1rem;\r\n  margin-bottom: 1rem;\r\n  align-items: center;\r\n}\r\n\r\n.label {\r\n  font-size: 0.9rem;\r\n  color: #444;\r\n}\r\n\r\n.dateInput {\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n  padding: 0.3rem 0.5rem;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.colorToggle {\r\n  display: flex;\r\n  align-items: center;\r\n  font-size: 0.9rem;\r\n  color: #444;\r\n}\r\n\r\n.loading {\r\n  padding: 2rem;\r\n  text-align: center;\r\n  color: #666;\r\n}\r\n\r\n.tableContainer {\r\n  overflow-x: auto;\r\n}\r\n\r\n.table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  table-layout: fixed; /* фиксируем, чтобы перенос работал */\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.table th,\r\n.table td {\r\n  border: 1px solid #ddd;\r\n  padding: 0.5rem;\r\n  text-align: center;\r\n  vertical-align: top;\r\n}\r\n\r\n/* Заголовки столбцов */\r\n.table th {\r\n  background-color: #f5f5f5;\r\n  font-weight: 600;\r\n  color: #333;\r\n  white-space: normal;\r\n  word-break: break-word;\r\n}\r\n\r\n/* Немного сузим столбцы со статусами */\r\n.statusHeader {\r\n  width: 70px;\r\n}\r\n\r\n/* Ширина колонки \"Товары\" */\r\n.productsHeader {\r\n  width: 200px;\r\n}\r\n\r\n/* Зебра-чередование строк */\r\n.table tr:nth-child(even) {\r\n  background-color: #fafafa;\r\n}\r\n\r\n/* Подсветка ячеек (цвет фона) */\r\n.greenCell {\r\n  background-color: #d4edda; /* бледно-зелёный фон */\r\n  color: #155724;\r\n  font-weight: 600;\r\n}\r\n\r\n.yellowCell {\r\n  background-color: #fff3cd; /* бледно-жёлтый фон */\r\n  color: #856404;\r\n  font-weight: 600;\r\n}\r\n\r\n.redCell {\r\n  background-color: #f8d7da; /* бледно-красный фон */\r\n  color: #721c24;\r\n  font-weight: 600;\r\n}\r\n\r\n/* Цвет текста для товаров */\r\n.greenText {\r\n  color: #28a745; /* насыщенный зелёный */\r\n  font-weight: 600;\r\n  font-size: 0.85rem;\r\n  margin-bottom: 2px;\r\n}\r\n\r\n.yellowText {\r\n  color: #ff9100; /* ярко-жёлтый */\r\n  font-weight: 600;\r\n  font-size: 0.85rem;\r\n  margin-bottom: 2px;\r\n}\r\n\r\n.redText {\r\n  color: #dc3545; /* насыщенный красный */\r\n  font-weight: 600;\r\n  font-size: 0.85rem;\r\n  margin-bottom: 2px;\r\n}\r\n\r\n\r\n/* Ячейка с товарами: текст выравнивается по левому краю, можно переносить */\r\n.productsCell {\r\n  text-align: left;\r\n  white-space: normal;\r\n  word-break: break-word;\r\n  padding: 0.4rem;\r\n}\r\n\r\n.noData {\r\n  padding: 1rem;\r\n  color: #777;\r\n  text-align: center;\r\n}\r\n\r\n\r\n.generateButton {\r\n  margin-left: 1rem;\r\n  padding: 0.5rem 1rem;\r\n  background-color: #007bff;\r\n  border: none;\r\n  color: #fff;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  font-size: 0.9rem;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.generateButton:disabled {\r\n  background-color: #6c757d;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.generateButton:not(:disabled):hover {\r\n  background-color: #0056b3;\r\n}\r\n\r\n/* ...остальные стили остаются без изменений... */\r\n\r\n.filterSelect {\r\n  margin-left: 0.5rem;\r\n  padding: 0.3rem 0.5rem;\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n  font-size: 0.9rem;\r\n  background-color: #fff;\r\n  cursor: pointer;\r\n}\r\n\r\n/* Если нужно, можно ещё чуть расширить ширину селекта */\r\n.filterSelect {\r\n  min-width: 120px;\r\n}\r\n\r\n.blueText {\r\n  color: #0066cc;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `SummaryReport_wrapper__UhsCP`,
	"title": `SummaryReport_title__0PGMz`,
	"controls": `SummaryReport_controls__85nVz`,
	"label": `SummaryReport_label__oNJ4M`,
	"dateInput": `SummaryReport_dateInput__0tBw4`,
	"colorToggle": `SummaryReport_colorToggle__9Zcsc`,
	"loading": `SummaryReport_loading__NeSxa`,
	"tableContainer": `SummaryReport_tableContainer__juEKr`,
	"table": `SummaryReport_table__BSPgX`,
	"statusHeader": `SummaryReport_statusHeader__4pnQb`,
	"productsHeader": `SummaryReport_productsHeader__UUutJ`,
	"greenCell": `SummaryReport_greenCell__H6CUq`,
	"yellowCell": `SummaryReport_yellowCell__AMtXB`,
	"redCell": `SummaryReport_redCell__mxpzt`,
	"greenText": `SummaryReport_greenText__PthMz`,
	"yellowText": `SummaryReport_yellowText__7zNM9`,
	"redText": `SummaryReport_redText__6w9xr`,
	"productsCell": `SummaryReport_productsCell__7rwMn`,
	"noData": `SummaryReport_noData__P9z0B`,
	"generateButton": `SummaryReport_generateButton__J1qr+`,
	"filterSelect": `SummaryReport_filterSelect__oMJI9`,
	"blueText": `SummaryReport_blueText__j4NcL`
};
export default ___CSS_LOADER_EXPORT___;
